export default "__VITE_ASSET__d5poVDzh__"